import { render, staticRenderFns } from "./textbook-edit.vue?vue&type=template&id=148c37ca&scoped=true&"
import script from "./textbook-edit.vue?vue&type=script&lang=ts&"
export * from "./textbook-edit.vue?vue&type=script&lang=ts&"
import style0 from "./textbook-edit.vue?vue&type=style&index=0&id=148c37ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c37ca",
  null
  
)

export default component.exports